<template>
  <v-card>
    <v-card-title>
      Estoque
      <v-spacer />
      <v-select
        v-model="selectedLocation"
        :items="locations"
        item-text="name"
        item-value="id"
        label="Filtrar por local"
        clearable
        class="ma-2"
        dense
        outlined
      />
      <v-select
        v-model="selectedCategory"
        :items="categories"
        item-text="name"
        item-value="id"
        label="Filtrar por Categoria"
        clearable
        class="ma-2"
        dense
        outlined
      />
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="balances"
      :loading="loading"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:[`item.qty`]="{ item }">
        {{ formataNumero(item.qty) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script lang="ts">
import { getStockBalances } from '../../services/estoque/estoque-servico';
import { getLocations } from '../../services/estoque/local-servico'; // você precisará disso
import { getCategories } from '../../services/estoque/categoria-servico';
export default {
  name: 'StockBalancesTab',

  data() {
    return {
      balances: [],
      locations: [],
      selectedLocation: null,
      categories: [],
      selectedCategory: null,
      loading: false,

      headers: [
        { text: 'Item', value: 'item_name' },
        { text: 'Categoria', value: 'category_name' },
        { text: 'Local', value: 'location_name' },
        { text: 'Quantidade', value: 'qty' },
      ],
    };
  },

  mounted() {
    this.loadLocations();
    this.loadBalances();
    this.loadCategories();
  },

  watch: {
    selectedLocation() {
      this.loadBalances();
      this.loadCategories();
    },

    selectedCategory() {
      this.loadBalances();
      this.loadLocations();
    },
  },

  computed: {
    formataNumero() {
      return value => {
        return value.toLocaleString('pt-BR');
      };
    },
  },

  methods: {
    async loadBalances() {
      this.loading = true;
      try {
        const data = await getStockBalances(this.selectedLocation, this.selectedCategory);
        this.balances = data;
      } catch (e) {
        console.error('Erro ao carregar estoque:', e);
      } finally {
        this.loading = false;
      }
    },

    async loadLocations() {
      try {
        const data = await getLocations();
        this.locations = data;
      } catch (e) {
        console.error('Erro ao carregar locais:', e);
      }
    },
    async loadCategories() {
      try {
        const data = await getCategories();
        this.categories = data;
      } catch (e) {
        console.error('Erro ao carregar categorias:', e);
      }
    },
  },
};
</script>
